<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  async created() {
    await this.$store.dispatch('setConfig');
    await this.$store.dispatch('login', { Vm: this });
  }
}
</script>

<style lang="scss">
body {
  line-height: 1;
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
}
.cube-popup-content {
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}
/* 通过 CSS 调整 cube-ui 的 picker 组件下拉时可见的选项数量 */
.cube-picker-wheel-item {
  font-size: 16px;
  /* height: 48px !important; */
  display: block;
  /* line-height: 48px; */
  color: #1A1A1A;
  /* transform: rotateX(0deg) !important; */
}
/* .cube-picker-content {
  top: 0px;
}
.cube-picker-wheel-wrapper > div {
  height: 247px;
}
.cube-picker-panel {
  height: 296px;
}
.cube-picker-content > i {
  height: 72px;
}
.border-top-1px {
  height: 145px !important;
} */
.cube-picker {
  .border-bottom-1px {
    // display: flex;
    // align-items: center;
    // justify-content: center;
    display: block;
    height: 48px;
    font-size: 16px;
    line-height: 48px;
    span {
      line-height: 48px;
    }
    .cube-picker-title {
      font-size: 16px;
      color: #1A1A1A;
    }
  }
}
</style>
